export default __webpack_public_path__ + "static/media/walkthrough-step2-fullHD.931ba466.jpg";